import axios from 'axios';
import { HttpService } from '../../../services/HttpService';
import { getSecureBaseUrl } from '../../../services/UrlMapperService';

import { apiUrls } from '../../../constants/apiUrl';

import { store } from '../../../configureStore';
import { hideLoader } from '../Loader/action';

/* *
 * Action clears the loader on the page.
 * */
export function disableLoader() {
  hideLoader(store.dispatch);
}

/* *
 * Action displays API error on the page.
 * */
/**
 * axios interceptor to intercept any outgoing API call
 * @param cbSuccess - called on API success
 * @param cbError - called on API failure
 */
export const interceptRequests = (cbSuccess, cbError) => {
  axios.interceptors.response.use(
    (response) => {
      if (cbSuccess && typeof cbSuccess === 'function') {
        cbSuccess(response);
      }
      return response;
    },
    (error) => {
      if (cbError && typeof cbError === 'function') {
        cbError(error);
      }
      return Promise.reject(error);
    },
  );
};

function keepSessionAlivePromise(continueSessionURL) {
  return axios.get(continueSessionURL);
}
/**
 * API to reset the session and keep it alive
 * @returns {Function}
 */
export const keepSessionAlive = (continueSessionURL) => () => keepSessionAlivePromise(continueSessionURL);

/**
 * API to reset the session
 * @returns {Function}
 */

function clearSessionPromise(clearSessionUrl) {
  return axios.get(clearSessionUrl);
}

export const clearSessionUrl = (clearSession) => () => clearSessionPromise(clearSession);

// Adding API call

export const sessionKeepAlive = (data) => ({
  type: 'SESSION_KEEP_ALIVE',
  data,
});

export const sessionLogoff = (data) => ({
  type: 'SESSION_LOGOFF',
  data,
});

export const sessionKeepAliveAPI = () => {
  const apiURL = `${getSecureBaseUrl()}${apiUrls().sessionKeepAlive}`;
  return HttpService.post(apiURL, {});
};

export const sessionKeepAliveSilent = () => ({
  type: 'SESSION_KEEP_ALIVE_SILENT',
});

export const sessionLogoffAPI = () => {
  // debugger;
  // const apiURL1 = `${getSecureBaseUrl()}`;
  // alert(apiURL1);
  // debugger;
  const apiURL = `${getSecureBaseUrl()}${apiUrls().sessionLogoff}`;
  // debugger;
  return HttpService.post(apiURL, {});
};
